/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';
import SelectedValue from '../selected-value/selected-value.component';
import chevronRightIcon from '../../../../../assets/chevron-right.svg';
import { filterStyles } from './units-filter.styles';
import { useIntl } from 'react-intl';
import { EUnitsOfDistance } from '../../../../../types';
import { useDispatch, useSelector } from 'react-redux';
import { selectUnitsOfDistance } from '../../../../../store/app/app.selector';
import { setUnitsOfDistance } from '../../../../../store/app/app.slice';

const UnitsFilter = () => {
    const intl = useIntl();
    const units = useSelector(selectUnitsOfDistance);
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useDispatch();

    const onSelectUnits = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value as EUnitsOfDistance;
        dispatch(setUnitsOfDistance(value));
    };

    return (
        <div css={filterStyles.root}>
            <div css={filterStyles.topBlock}>
                <div css={filterStyles.headerWrapper}>
                    <span css={filterStyles.title}>
                        {intl.formatMessage({ id: 'unitsOfMeasurement' })}
                    </span>
                    <SelectedValue
                        value={`${intl.formatMessage({ id: units === EUnitsOfDistance.MILES ? 'units.miles' : 'units.kilometers' })}`}
                    />
                </div>
                <img
                    css={
                        isOpen
                            ? [filterStyles.chevronIcon, filterStyles.chevronIconOpen]
                            : filterStyles.chevronIcon
                    }
                    src={chevronRightIcon}
                    alt="chevron-right"
                    onClick={() => setIsOpen(!isOpen)}
                />
            </div>
            {isOpen && (
                <div css={filterStyles.contentWrapper}>
                    <label css={filterStyles.radioInput}>
                        <input
                            value={EUnitsOfDistance.MILES}
                            checked={units == EUnitsOfDistance.MILES}
                            type="radio"
                            onChange={onSelectUnits}
                        />
                        <span css={filterStyles.labelSpan}>{`${intl.formatMessage({
                            id: `units.${EUnitsOfDistance.MILES}`,
                        })}`}</span>
                    </label>
                    <label css={filterStyles.radioInput}>
                        <input
                            value={EUnitsOfDistance.KILOMETERS}
                            checked={units == EUnitsOfDistance.KILOMETERS}
                            type="radio"
                            onChange={onSelectUnits}
                        />
                        <span css={filterStyles.labelSpan}>{`${intl.formatMessage({
                            id: `units.${EUnitsOfDistance.KILOMETERS}`,
                        })}`}</span>
                    </label>
                </div>
            )}
        </div>
    );
};

export default UnitsFilter;
